import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Text } from '@chakra-ui/react';
import { TEXT_STYLES } from '@client/theme';
const LABEL_GAP = 1.5;
export const FormSection = ({ label, children, }) => (_jsxs(Stack, { gap: LABEL_GAP, align: "flex-start", children: [_jsx(Text, { textStyle: TEXT_STYLES.fieldLabel, children: label }), children] }));
